var _path, _path2, _path3, _path4, _rect, _rect2, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEvent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.857 2.535h47.104v44.2c0 1.71-1.087 3.097-2.427 3.097H2.427C1.087 49.832 0 48.445 0 46.735V5.237c0-1.492 1.28-2.702 2.857-2.702z",
    fill: "#fff",
    stroke: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.427 2.236h45.107c1.34 0 2.427 1.035 2.427 2.312v9.983H0V4.548C0 3.27 1.087 2.236 2.427 2.236z",
    fill: "#F58341"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.53h49.961v5.406H0v-5.405z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "M0 13.065h49.961v1.466H0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.4,
    width: 3.052,
    height: 7.084,
    rx: 1.183,
    fill: "#DFE1E7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.897,
    width: 3.052,
    height: 7.084,
    rx: 1.183,
    fill: "#DFE1E7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.143 35.724c0 2.978-2.182 4.817-5.021 4.817-2.395 0-3.92-.898-4.98-2.343l1.081-1.204c.933 1.226 2.161 1.927 3.899 1.927 1.928 0 3.262-1.358 3.262-3.131 0-1.927-1.334-3.152-3.241-3.152-1.25 0-2.31.415-3.263 1.379l-1.292-.46v-7.881h8.644v1.62h-6.886v5.079c.678-.7 1.886-1.314 3.305-1.314 2.352 0 4.492 1.664 4.492 4.663zm-14.286 3.192v1.625H12.88v-1.45c5.229-4.15 8.061-6.587 8.061-9.112 0-1.866-1.525-2.678-3.028-2.678-1.743 0-3.094.746-3.943 1.844l-1.112-1.164c1.112-1.47 3.007-2.305 5.055-2.305 2.418 0 4.88 1.383 4.88 4.303 0 2.986-3.007 5.71-7.059 8.937h7.124z",
    fill: "#707070"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEvent);
export default __webpack_public_path__ + "static/media/icon-event.a527871232f90240665cc2ba4ab183d5.svg";
export { ForwardRef as ReactComponent };